import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { checkIsAppPage } from 'tools/loaction';

interface RouteLinkProps extends LinkProps {}
export default function RouteLink(props: RouteLinkProps) {
    return (
        <Link {...props} reloadDocument={props.reloadDocument || checkIsAppPage()}>
            {props.children}
        </Link>
    );
}
